import { FC, useEffect } from 'react';

import { I18nProvider, useTranslation } from '@i18n';
import { Box, Stack } from '@sparky';

import FacebookButton from './buttons/FacebookButton';
import LinkedInButton from './buttons/LinkedInButton';
import TwitterButton from './buttons/TwitterButton';
import { ShareOnSocialsProvider, useShareParams } from './ShareOnSocialsContext';
import { ShareParams } from './types';

export type Props = {
  label?: string;
} & ShareParams;

const ShareOnSocials: FC<Props> = ({ ...props }) => {
  return (
    <I18nProvider dictionary={locale => import(`./content/${locale}.json`)}>
      <ShareOnSocialsProvider>
        <InnerShareOnSocials {...props}></InnerShareOnSocials>
      </ShareOnSocialsProvider>
    </I18nProvider>
  );
};

const InnerShareOnSocials: FC<Props> = ({ label, text, url }) => {
  const { t } = useTranslation();
  const { setShareParams } = useShareParams();

  useEffect(() => {
    (text || text === '') && setShareParams(prevState => ({ ...prevState, text }));
    (url || url === '') && setShareParams(prevState => ({ ...prevState, url }));
  }, [setShareParams, text, url]);

  const accessibiltyLabel = t('shareLabel');

  return (
    <Stack alignX="center" alignY="center" direction="row" wrap={false}>
      {label && (
        <Stack.Item>
          <Box paddingRight="4">{label}</Box>
        </Stack.Item>
      )}
      <Stack.Item>
        <LinkedInButton label={`${accessibiltyLabel} LinkedIn`} />
      </Stack.Item>
      <Stack.Item>
        <TwitterButton label={`${accessibiltyLabel} Twitter`} />
      </Stack.Item>
      <Stack.Item>
        <FacebookButton label={`${accessibiltyLabel} Facebook`} />
      </Stack.Item>
    </Stack>
  );
};

export default ShareOnSocials;
